import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import PropTypes from 'prop-types';
import { contains } from '@utiljs/dom';
import createRef from '@roo/create-react-ref/createRef';
import { isFunction } from '@utiljs/is';
import omit from 'lodash/omit';

var ClickOutside = /*#__PURE__*/function (_React$Component) {
  _inherits(ClickOutside, _React$Component);

  var _super = _createSuper(ClickOutside);

  function ClickOutside() {
    var _this;

    _classCallCheck(this, ClickOutside);

    _this = _super.apply(this, arguments);
    _this.wrapperRef = createRef(); // 使用 forwardRef 可以不用设置 display 属性， 但是不兼容 16.3 以下，所以此方案暂缓
    // handleClickOutside = (event: MouseEvent) => {
    //     const {
    //         onClickOutSide
    //     } = this.props;
    //     let domNode = null;
    //     if (this.wrapperRef.current) {
    //         domNode = this.wrapperRef.current;
    //     } else {
    //         // findDOMNode 缺陷： children 类型只能是 Element；性能。好处是不用处理 ref
    //         // https://react.docschina.org/docs/strict-mode.html?#warning-about-deprecated-finddomnode-usage
    //         // eslint-disable-next-line
    //         domNode = ReactDOM.findDOMNode(this);
    //     }
    //     if (!domNode || !contains((domNode as HTMLElement), (event.target as HTMLElement))) {
    //         if (isFunction(onClickOutSide)) {
    //             onClickOutSide(event);
    //         }
    //     }
    // }

    _this.handleClickOutside = function (event) {
      var onClickOutside = _this.props.onClickOutside;
      var domNode = _this.wrapperRef.current;

      if (!domNode || !contains(domNode, event.target)) {
        if (isFunction(onClickOutside)) {
          onClickOutside(event);
        }
      }
    };

    _this.addClickOutside = function (useCapture) {
      document.addEventListener('click', _this.handleClickOutside, {
        capture: useCapture
      });
    };

    _this.removeClickOutside = function (useCapture) {
      document.removeEventListener('click', _this.handleClickOutside, {
        capture: useCapture
      });
    };

    return _this;
  }

  _createClass(ClickOutside, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          useCapture = _this$props.useCapture;
      if (!disabled) this.addClickOutside(useCapture);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var useCapture = this.props.useCapture;
      this.removeClickOutside(useCapture);
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          children = _a.children,
          display = _a.display,
          others = __rest(_a, ["children", "display"]);

      var style = {
        display: display
      };
      var otherProps = omit(others, ['useCapture', 'onClickOutside']);
      return /*#__PURE__*/React.createElement("div", _Object$assign({
        ref: this.wrapperRef,
        style: style
      }, otherProps), children);
    }
  }]);

  return ClickOutside;
}(React.Component);

export { ClickOutside as default };
ClickOutside.propTypes = {
  onClickOutside: PropTypes.func,
  display: PropTypes.string,
  disabled: PropTypes.bool,
  useCapture: PropTypes.bool
};
ClickOutside.defaultProps = {
  onClickOutside: function onClickOutside() {},
  display: 'inline-block',
  disabled: false,
  useCapture: true
};